import { API_KEYS } from 'shared/store/listingV2/constants';

export const removeSingleFilter = (
  key: string,
  id: string,
  appliedFilters: Record<string, string>
) => {
  let newAppliedFilters = { ...appliedFilters };

  if (key !== API_KEYS.PRICE_FILTER) {
    const value = newAppliedFilters[key]
      .split('_')
      .filter((filterId) => filterId !== id)
      .join('_');
    if (value.length > 0) newAppliedFilters[key] = value;
    else delete newAppliedFilters[key];
  } else {
    delete newAppliedFilters[API_KEYS.PRICE_FILTER];
  }
  return newAppliedFilters;
};
